import React, { Component } from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import withRole from 'components/Security/withRole';
import {
  ROLE_CREATE_USER,
  ROLE_EDIT_USER,
  ROLE_SHOW_USER,
} from 'helpers/roles';

import List from './Users';
import UserForm from './UserForm';
import AddUserForm from './AddUserForm';

class Users extends Component {
  render() {
    const { props } = this;

    const EditForm = withRole(ROLE_EDIT_USER, UserForm);
    const CreateForm = withRole(ROLE_CREATE_USER, AddUserForm);
    const ListSecured = withRole(ROLE_SHOW_USER, List);

    return (
      <DataGridStateContextProvider>
        <Router history={this.props.history}>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.url}/`}
              render={parentProps => <ListSecured {...props} {...parentProps} />}
            />
            <Route
              path={`${this.props.match.url}/add`}
              render={() => <CreateForm {...props} />}
            />
            <Route
              path={`${this.props.match.url}/edit/:id`}
              render={parentProps => <EditForm {...props} {...parentProps} />}
            />
          </Switch>
        </Router>
      </DataGridStateContextProvider>
    );
  }
}

export default withRouter(Users);
